import React, { useEffect, useRef } from "react";

export default function LogoSlider() {
  const logos = [
    require("../assests/1.jpg"),
    require("../assests/2.jpg"),
    require("../assests/3.jpg"),
    require("../assests/4.jpg"),
    require("../assests/5.jpg"),
    require("../assests/6.jpg"),
    require("../assests/7.jpg"),
    require("../assests/8.jpg"),
    require("../assests/9.jpg"),
    require("../assests/10.jpg"),
    require("../assests/11.jpg"),
    require("../assests/12.jpg"),
    require("../assests/13.jpg"),
    require("../assests/14.jpg"),
    require("../assests/15.png"),
    require("../assests/16.png"),
    require("../assests/17.png"),
    require("../assests/18.png"),
  ];

  // repeat logos twice for seamless loop
  const track = [...logos, ...logos];
  const containerRef = useRef(null);
  const isUserScrolling = useRef(false);
  const resumeTimer = useRef(null);
  const animationId = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const speed = 0.96; // pixels per frame (~36px/s at 60fps)

    const step = () => {
      if (!isUserScrolling.current) {
        container.scrollLeft += speed;
        const half = container.scrollWidth / 2;
        if (container.scrollLeft >= half) {
          container.scrollLeft -= half;
        }
      }
      animationId.current = requestAnimationFrame(step);
    };

    animationId.current = requestAnimationFrame(step);

    // pause auto-scroll when user interacts
    const handleScroll = () => {
      isUserScrolling.current = true;
      clearTimeout(resumeTimer.current);
      resumeTimer.current = setTimeout(() => {
        isUserScrolling.current = false;
      }, 10);
    };

    container.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      cancelAnimationFrame(animationId.current);
      clearTimeout(resumeTimer.current);
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const STRIP_HEIGHT = "clamp(100px, 18vw, 160px)";
  const GAP = 40;

  const wrapper = {
    padding: "24px 16px",
    background: "#fff",
    fontFamily: "system-ui, sans-serif",
  };

  const heading = { textAlign: "center", marginBottom: 20 };
  const title = { fontSize: "clamp(20px, 4vw, 36px)", fontWeight: 700, margin: 0 };
  const subtitle = { fontSize: "clamp(14px, 2.5vw, 18px)", opacity: 0.7 };

  const slider = {
    display: "flex",
    gap: `${GAP}px`,
    overflowX: "auto",
    height: STRIP_HEIGHT,
    scrollBehavior: "smooth",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
  };

  const item = {
    flex: "0 0 auto",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const img = {
    height: "100%",
    width: "auto",
    objectFit: "contain",
    userSelect: "none",
    pointerEvents: "none",
    filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.08))",
    transition: "transform 0.2s ease",
  };

  return (
    <div style={wrapper}>
      <div style={heading}>
        <h2 style={title}>Our Partner Clients</h2>
        <p style={subtitle}>Trusted brands we've worked with</p>
      </div>

      <style>{`
        .logo-track::-webkit-scrollbar { display: none; }
      `}</style>

      <div ref={containerRef} className="logo-track" style={slider}>
        {track.map((src, i) => (
          <div style={item} key={i}>
            <img src={src} alt={`partner-${i % logos.length}`} style={img} />
          </div>
        ))}
      </div>
    </div>
  );
}



  // const container = {
  //   height:"500px",
  //   padding: "24px",
  //   background: "#0b1535",
  //   color: "white",
  //   fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
  // };

  // const headingWrap = {
  //   textAlign: "center",
  //   marginBottom: "90px",
  // };

  // const h1 = { fontSize: 60, margin: 0, fontWeight: 700, letterSpacing: 0.3 ,marginBottom:20};
  // const sub = {
  //   fontSize: 35,
  //   margin: "6px 0 14px",
  //   opacity: 0.85,
  //   letterSpacing: 0.2,
  // };

  // const sliderStyles = {
  //   position: "relative",
  //   width: "100%",
  //   overflow: "hidden",
  //   height: `${STRIP_HEIGHT}px`,
  // };

  // const trackStyles = {
  //   display: "flex",
  //   alignItems: "center",
  //   height: "100%",
  //   gap: `${GAP}px`,
  //   listStyle: "none",
  //   padding: 0,
  //   margin: 0,
  //   animation: `slide ${SPEED}s linear infinite`,
  //   willChange: "transform",
  // };

  // const itemStyles = {
  //   flex: "0 0 auto",
  //   height: "100%",
  //   display: "flex",
  //   alignItems: "center",
  // };

  // const imgStyles = {
  //   height: "100%",
  //   width: "auto",
  //   objectFit: "contain",
  //   opacity: 0.95,
  //   userSelect: "none",
  //   pointerEvents: "none", // prevents accidental drag stutters
  //   transition: "transform .2s ease, opacity .2s ease",
  // };
